import React, { useEffect } from "react";
import s from "./Modal.module.scss";

export default function Modal({ isOpen, onClose, title, children }) {
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={s.overlay} onMouseDown={onClose} role="dialog" aria-modal="true">
      <div className={s.modal} onMouseDown={(e) => e.stopPropagation()}>
        <div className={s.top}>
          <div className={s.titleWrap}>
            {title ? <h3 className={s.title}>{title}</h3> : null}
          </div>

          <button type="button" className={s.close} onClick={onClose} aria-label="Закрыть">
            ✕
          </button>
        </div>

        <div className={s.body}>{children}</div>
      </div>
    </div>
  );
}
